import { createContext } from 'react'

const TrainingPortalThemeContext = createContext({ clientPortalTheme: null })

export default TrainingPortalThemeContext
